import api from "../instance";
import { serverBaseUrl } from "../apiConstants";

const appService = {
  getUserTimeline: (userId, count) => {
    return api.post(`${serverBaseUrl}/tweets/recent`, {
      count: count || 5,
      username: userId,
    });
  },
  getTweetsByUserName: (id, count, publicKey, jwt) => {
    return api.post(`${serverBaseUrl}/tweets/get-tweets`, {
      count: count || 5,
      user_id: id,
      public_key: publicKey,
      jwt: jwt,
    });
  },
  postSelectedTweets: (data) => {
    return api.post(
      `${serverBaseUrl}/tweets/upload-images-selected-tweets`,
      data
    );
  },
};

export default appService;
